import React from 'react';
import { EnhancedImage } from '@teko/teko-ecommerce';
import { BannerEntity } from '@teko/ecommerce';
import { styled, Glide, GlideElement } from '@teko/ds-desktop';
import { getTrackingData } from '@teko/tracking';
import { isServerless } from '../../../helpers';

const serverless = isServerless();

export interface BannerSlidesProps {
  banners: Array<BannerEntity>;
  imageWidth?: number;
  sliderRef?: React.RefObject<GlideElement>;
  prioritized?: boolean;
}

export const BannerSlides: React.FC<BannerSlidesProps> = ({
  banners,
  imageWidth = 1920,
  sliderRef,
  prioritized,
}: BannerSlidesProps) => {
  if (!banners.length) return null;
  return (
    <StyledGlide
      ref={sliderRef}
      perView={1}
      autoplay={3000}
      type="carousel"
      showControl={false}
      showBullet
    >
      {banners.map((banner, index: number) => (
        <SlideWrapper
          className="glide__slide"
          key={index}
          {...getTrackingData({
            isTrackContent: true,
            regionName: 'topSliderBannerHomepage',
            contentName: banner.campaignName,
            target: banner.targetPath,
            index,
          })}
        >
          <EnhancedImage
            googleImageParams={{
              width: imageWidth,
            }}
            link={{
              href:
                serverless &&
                banner.targetPath &&
                banner.targetPath.startsWith(location.origin)
                  ? banner.targetPath.replace(location.origin, '')
                  : banner.targetPath,
            }}
            objectFit="cover"
            width="100%"
            height={566}
            src={banner.image}
            thumbnail={banner.thumbnail}
            alt={banner.campaignName}
            lazy={index === 0 ? false : true}
            fetchPriority={
              index === 0 ? (prioritized ? 'high' : 'auto') : 'low'
            }
          />
        </SlideWrapper>
      ))}
    </StyledGlide>
  );
};

const StyledGlide = styled(Glide)`
  .glide__bullets--override {
    bottom: 7em;
  }

  .glide__bullet--active {
    background-color: ${({ theme }) => theme.colors.primary};
  }

  .glide__slide a {
    width: 100%;
  }
`;

const SlideWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
